import { customBlogListReducer, CustomBlogListState } from "@iewc/Store/State/Blog/BlogListState";
import customSetInventoryResultsReducer from "@iewc/Store/State/Cart/CustomSetInventoryResultsModalReducer";
import CustomSetInventoryResultsModalState from "@iewc/Store/State/Cart/CustomSetInventoryResultsModalState";
import { customCategoriesReducer } from "@iewc/Store/State/Categories/CategoriesReducer";
import { CustomCategoriesState } from "@iewc/Store/State/Categories/CategoriesState";
import customCheckoutReviewAndSubmitReducer from "@iewc/Store/State/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitReducer";
import { CheckoutReviewAndSubmitState } from "@iewc/Store/State/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitState";
import { customCheckoutShippingReducer } from "@iewc/Store/State/CheckoutShipping/CheckoutShippingReducer";
import { CustomCheckoutShippingState } from "@iewc/Store/State/CheckoutShipping/CheckoutShippingState";
import customCreateAccountFormReducer from "@iewc/Store/State/CreateAccount/CreateAccountFormReducer";
import CreateAccountFormState from "@iewc/Store/State/CreateAccount/CreateAccountFormState";
import { customCountriesReducer, CustomCountriesState } from "@iewc/Store/State/Custom/CustomCountriesState";
import { customDownloadsReducer, CustomDownloadsState } from "@iewc/Store/State/Custom/CustomDownloadsState";
import { customLoadingPriceReducer, CustomLoadingPriceState } from "@iewc/Store/State/Custom/CustomLoadingPrice";
import { customModalsReducer, CustomModalsState } from "@iewc/Store/State/Custom/CustomModalsState";
import customSetSpoolModalReducer, { CustomSpoolModalState } from "@iewc/Store/State/Custom/CustomSpoolModalState";
import { customSystemListReducer, CustomSystemListState } from "@iewc/Store/State/Custom/CustomSystemListState";
import customInstantRegistrationFormReducer from "@iewc/Store/State/InstantRegistration/InstantRegistrationFormReducer";
import InstantRegistrationFormState from "@iewc/Store/State/InstantRegistration/InstantRegistrationFormState";
import customNewShippingAddressFormReducer from "@iewc/Store/State/NewShippingAddress/NewShippingAddressFormReducer";
import NewShippingAddressFormState from "@iewc/Store/State/NewShippingAddress/NewShippingAddressFormState";
import customProductListReducer from "@iewc/Store/State/ProductList/ProductListReducer";
import { CustomProductListState } from "@iewc/Store/State/ProductList/ProductListState";
import customRequestQuoteFormReducer from "@iewc/Store/State/RfqRequestQuote/RequestQuoteFormReducer";
import RequestQuoteFormState from "@iewc/Store/State/RfqRequestQuote/RequestQuoteFormState";
import {
    customPurchasesByProductReducer,
    CustomPurchasesByProductState,
} from "@iewc/Store/State/SpendReporting/PurchasesByProductState";
import {
    customSpendReportingReducer,
    CustomSpendReportingState,
} from "@iewc/Store/State/SpendReporting/SpendReportingState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

export type CustomState = {
    name: string;
    customCategories: CustomCategoriesState;
    blogList: CustomBlogListState;
    checkoutShipping: CustomCheckoutShippingState;
    customRequestQuoteForm: RequestQuoteFormState;
    customCreateAccountForm: CreateAccountFormState;
    customModals: CustomModalsState;
    customSystemList: CustomSystemListState;
    customCountriesList: CustomCountriesState;
    customReviewAndSubmit: CheckoutReviewAndSubmitState;
    customDownloads: CustomDownloadsState;
    customInventoryResultsModal: CustomSetInventoryResultsModalState;
    customNewShippingAddressForm: NewShippingAddressFormState;
    spendReportingState: CustomSpendReportingState;
    customProductList: CustomProductListState;
    customSpoolModal: CustomSpoolModalState;
    customPurchasesByProductState: CustomPurchasesByProductState;
    customIsLoadingPrice: CustomLoadingPriceState;
    customInstantRegistrationForm: InstantRegistrationFormState;
} & ApplicationState;

(reducers as any).customCategories = customCategoriesReducer;
(reducers as any).blogList = customBlogListReducer;
(reducers as any).checkoutShipping = customCheckoutShippingReducer;
(reducers as any).customRequestQuoteForm = customRequestQuoteFormReducer;
(reducers as any).customCreateAccountForm = customCreateAccountFormReducer;
(reducers as any).customModals = customModalsReducer;
(reducers as any).customSystemList = customSystemListReducer;
(reducers as any).customCountriesList = customCountriesReducer;
(reducers as any).customReviewAndSubmit = customCheckoutReviewAndSubmitReducer;
(reducers as any).customDownloads = customDownloadsReducer;
(reducers as any).customInventoryResultsModal = customSetInventoryResultsReducer;
(reducers as any).customNewShippingAddressForm = customNewShippingAddressFormReducer;
(reducers as any).spendReportingState = customSpendReportingReducer;
(reducers as any).customProductList = customProductListReducer;
(reducers as any).customSpoolModal = customSetSpoolModalReducer;
(reducers as any).customPurchasesByProductState = customPurchasesByProductReducer;
(reducers as any).customIsLoadingPrice = customLoadingPriceReducer;
(reducers as any).customInstantRegistrationForm = customInstantRegistrationFormReducer;

type Reducers = {
    customCategories: typeof customCategoriesReducer;
    customBlogListReducer: typeof customBlogListReducer;
    customCheckoutShippingReducer: typeof customCheckoutShippingReducer;
    customRequestQuoteForm: typeof customRequestQuoteFormReducer;
    customCreateAccountForm: typeof customRequestQuoteFormReducer;
    customModals: typeof customModalsReducer;
    customSystemList: typeof customSystemListReducer;
    customReviewAndSubmit: typeof customCheckoutReviewAndSubmitReducer;
    customDownloads: typeof customDownloadsReducer;
    customInventoryResultsModal: typeof customSetInventoryResultsReducer;
    customNewShippingAddressForm: typeof customNewShippingAddressFormReducer;
    spendReportingState: typeof customSpendReportingReducer;
    customProductList: typeof customProductListReducer;
    customSpoolModal: typeof customSetSpoolModalReducer;
    customIsLoadingPrice: typeof customLoadingPriceReducer;
    customPurchasesByProductReducer: typeof customPurchasesByProductReducer;
    customInstantRegistrationForm: typeof customInstantRegistrationFormReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
